<template>
  <trade-history-list
    :login-type="loginType"
  ></trade-history-list>
</template>

<script>
// 跟交易报告的交易历史一样,loginType不一样
import tradeHistoryList from "@/views/customer/traderReport/tradeHistoryList";
export default {
  name: "index",
  components: {
    tradeHistoryList
  },
  data() {
    return {
      loginType: 2,
    }
  },
}
</script>

<style scoped>

</style>
